import React from "react";
import IconPreview from "./IconPreview";

const RvTilePreview = ({ config, classes }) => {
  return (
    <div className={`${classes} rv-tile`}>
      {config.icon && <IconPreview icon={config.icon || ""} />}
      <span>{config.title}</span>
    </div>
  );
};

export default RvTilePreview;
